import React                                  from 'react';
import { Link, useHistory, }                  from 'react-router-dom';
import { Button, Container, Divider, Header } from 'semantic-ui-react';
import { Cell, Grid }                         from "styled-css-grid";

import { RouterUtility }                                  from '../../../util';
import { CorvalUtilHexColors, SemanticUIColor }           from '../../../types';
import { GenericContentLayout, Page }                     from '../../containers';
import { PageMeta }                                       from '../../containers/PageMeta';
import { CorvalStylizedHexContainer }                     from '../../components/product/CorvalStylizedHexContainer';
import { CHARACTER_VISUAL_AID, CorvalCharacterVisualAid } from '../../components/product/CorvalCharacterVisualAid';
import { HelpAndSupportStatement }                        from '../../components/util/messaging/HelpAndSupportStatement';

export default () => {
	
	let history = useHistory();
	
	const handleGoHome = () => {
		
		history.push( RouterUtility.getRoute( 'HOME' ) );
	}
	
	return (
		
		<Page name={ 'not-found' } showTop={ true } showNav={ false } padMainHorizontal={ true } padMainVertical={ true } showBrand={ true }>
			
			<CorvalStylizedHexContainer inverted fill={ 'area' } bgColor={ SemanticUIColor.BLUE } fadeColor={ CorvalUtilHexColors.DARK_BLUE } fadeDirection={ 'down' }/>
			
			<PageMeta title={ 'Page Not Found' }>
				
				<Container>
					
					<GenericContentLayout
						topAreaComponent={ null }
						withTopSideArea={ false }
						withBottomSideArea={ false }>
						
						<Grid columns={ `300px auto` } rows={ `auto auto` } columnGap={ '50px' }>
							<Cell>
								
								<CorvalCharacterVisualAid fluid={ true } type={ CHARACTER_VISUAL_AID.CORVAL_HEX_INTERFACING_WITH_USERS }/>
							
							</Cell>
							<Cell>
								
								<Header as={ 'h2' } dividing>Page Not Found</Header>
								<p className={ 'text--md text-height--xl' }>The page you are looking for cannot be found.</p>
								<p className={ 'text--md text-height--xl' }><HelpAndSupportStatement contactName={ `Corval's Support Team` }/></p>
								
								<Divider/>
							
							</Cell>
							<Cell top={ 2 } left={ 2 } className={ 'text-right' }>
								
								<Button onClick={ handleGoHome } primary basic>Go Home</Button>
							
							</Cell>
						</Grid>
					
					</GenericContentLayout>
				</Container>
			
			</PageMeta>
		
		</Page>
	
	);
}
